import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { APP_URLS } from '../helpers/url_helper';
import Home from '../pages/Home/Home';
import Login from '../pages/Login/Login';
import Signup from '../pages/Signup/Signup';
import CompanySignup from '../pages/Signup/CompanySignup';
import IndividualSignUp from '../pages/Signup/IndividualSignUp';
import CompleteProfile from '../pages/Signup/CompleteProfile';
import ForgotPassword from '../pages/Auth/ForgotPassword';
import ForgotPasswordOTP from '../pages/Auth/ForgotPasswordOTP';
import Resetpassword from '../pages/Auth/Resetpassword';
import DashboardLayout from '../pages/Dashboard/DashboardLayout';
import Dashboard from '../pages/Dashboard/Dashboard';
import Assistant from '../pages/Other/Assistant';
import Directassistant from '../pages/Other/Directassistant';
import Documents from '../pages/Documents/Documents';
import Projects from '../pages/Projects/Projects';
import Tasks from '../pages/Projects/Tasks';
import TaskDetails from '../pages/Projects/TaskDetails';
import AllTasks from '../pages/Projects/AllTasks';
import Employees from '../pages/ManageEmployee/Employees';
import EmployeeDetails from '../pages/ManageEmployee/EmployeeDetails';
import Roles from '../pages/ManageEmployee/Roles';
import RolePermission from '../pages/ManageEmployee/RolePermission';
import Subscription from '../pages/Subscription/Subscription';
import NewSubscription from '../pages/Signup/newSubscription';
import CheckoutSession from '../pages/StripePayment/CheckoutSession';
import PaymentSuccess from '../pages/StripePayment/PaymentSuccess';
import PaymentCancel from '../pages/StripePayment/PaymentCancel';
import StandaloneCheckoutSession from '../pages/StripePayment/StandaloneCheckoutSession';
import StandalonePaymentSuccess from '../pages/StripePayment/StandalonePaymentSuccess';
import StandalonePaymentCancel from '../pages/StripePayment/StandalonePaymentCancel';
import Profile from '../pages/Profile/Profile';
import Settings from '../pages/Settings/Settings';
import ProtectedRoute from './ProtectedRoute';
import TermsAndConditions from '../pages/TermsAndPolicy/TermsAndConditions';
import PrivacyPolicy from '../pages/TermsAndPolicy/PrivacyPolicy';
import ContactUs from '../pages/ContactUs/ContactUs';
import Enquiry from '../pages/ContactUs/Enquiry';
import StandaloneContactSales from '../pages/ContactUs/StandaloneContactSales';
import ContactSales from '../pages/ContactUs/ContactSales';
// import other pages as needed

const AppRoutes = () => (
  <Routes>
    {/* Public policy pages */}
    <Route path="/terms" element={<TermsAndConditions />} />
    <Route path="/privacy" element={<PrivacyPolicy />} />
    <Route path={APP_URLS.HOME} element={<Home />} />
    <Route path={APP_URLS.LOGIN} element={<Login />} />
    <Route path={APP_URLS.SIGNUP} element={<Signup />} />
    <Route path="/directassistant" element={<Directassistant />} />
    <Route path="/company-signup" element={<CompanySignup />} />
    <Route path="/individual-signup" element={<IndividualSignUp />} />
    <Route path="/newSubscription" element={<NewSubscription />} />
    <Route path={APP_URLS.STANDALONE_CONTACT_SALES} element={<StandaloneContactSales />} />
    {/* Standalone checkout pages (no sidebar) for newSubscription flow */}
    <Route path="/standalone-checkout" element={<StandaloneCheckoutSession />} />
    <Route path="/standalone-payment-success" element={<StandalonePaymentSuccess />} />
    <Route path="/standalone-payment-cancel" element={<StandalonePaymentCancel />} />
    <Route path={APP_URLS.FORGOT_PASSWORD} element={<ForgotPassword />} />
    <Route path={APP_URLS.FORGOT_PASSWORD_OTP} element={<ForgotPasswordOTP />} />
    <Route path={APP_URLS.RESET_PASSWORD} element={<Resetpassword />} />
    {/* Public Contact pages */}
    <Route path="/contact-us" element={<ContactUs />} />
    <Route path="/enquiry" element={<Enquiry />} />
    <Route element={<ProtectedRoute />}>
      <Route path="/complete-profile" element={<CompleteProfile />} />
      <Route path={APP_URLS.DASHBOARD} element={<DashboardLayout />}>
        <Route index element={<Dashboard />} />
      </Route>
      {/* Dashboard layout routes without /dashboard prefix */}
      <Route path={APP_URLS.ASSISTANT} element={<DashboardLayout />}>
        <Route index element={<Assistant />} />
      </Route>
      <Route path={APP_URLS.PROJECTS} element={<DashboardLayout />}>
        <Route index element={<Projects />} />
      </Route>
      <Route path="/manage-task" element={<DashboardLayout />}>
        <Route index element={<AllTasks />} />
      </Route>
      <Route path="/project/:projectId/tasks" element={<DashboardLayout />}>
        <Route index element={<Tasks />} />
      </Route>
      <Route path="/project/:projectId/task/:taskId" element={<DashboardLayout />}>
        <Route index element={<TaskDetails />} />
      </Route>
      <Route path={APP_URLS.DOCUMENTS} element={<DashboardLayout />}>
        <Route index element={<Documents />} />
      </Route>
      <Route path={APP_URLS.EMPLOYEES} element={<DashboardLayout />}>
        <Route index element={<Employees />} />
      </Route>
      <Route path={APP_URLS.EMPLOYEE_DETAILS} element={<DashboardLayout />}>
        <Route index element={<EmployeeDetails />} />
      </Route>
      <Route path={APP_URLS.ROLES} element={<DashboardLayout />}>
        <Route index element={<Roles />} />
      </Route>
      <Route path={APP_URLS.ROLE_PERMISSION} element={<DashboardLayout />}>
        <Route index element={<RolePermission />} />
      </Route>
      <Route path={APP_URLS.SUBSCRIPTION} element={<DashboardLayout />}>
        <Route index element={<Subscription />} />
      </Route>
      <Route path={APP_URLS.CONTACT_SALES} element={<DashboardLayout />}>
        <Route index element={<ContactSales />} />
      </Route>
      <Route path={APP_URLS.PROFILE} element={<DashboardLayout />}>
        <Route index element={<Profile />} />
      </Route>
      <Route path="/settings" element={<DashboardLayout />}>
        <Route index element={<Settings />} />
      </Route>
      {/* Stripe Payment Routes - Inside dashboard layout */}
      <Route path={APP_URLS.CHECKOUT} element={<DashboardLayout />}>
        <Route index element={<CheckoutSession />} />
      </Route>
      <Route path={APP_URLS.PAYMENT_SUCCESS} element={<DashboardLayout />}>
        <Route index element={<PaymentSuccess />} />
      </Route>
      <Route path={APP_URLS.PAYMENT_CANCEL} element={<DashboardLayout />}>
        <Route index element={<PaymentCancel />} />
      </Route>
    </Route>
    {/* Add more routes here as needed */}
  </Routes>
);

export default AppRoutes; 